<template>
  <v-layout column>
    <v-flex> <span class="font-weight-medium">appKey:</span> {{ appKey }} </v-flex>
    <v-flex> <span class="font-weight-medium">offer:</span> {{ offer }} </v-flex>
    <v-flex> <span class="font-weight-medium">version:</span> {{ version }} </v-flex>
    <v-flex> <span class="font-weight-medium">deviceType:</span> {{ deviceType }} </v-flex>

    <v-flex class="mt-3"> <span class="font-weight-medium">sessionId:</span> {{ sessionId }} </v-flex>
    <v-flex> <span class="font-weight-medium">url:</span> {{ url }} </v-flex>
    <v-flex> <span class="font-weight-medium">userAgent:</span> {{ userAgent }} </v-flex>
    <v-flex> <span class="font-weight-medium">layoutId:</span> {{ layoutId }} </v-flex>

    <v-flex class="mt-3"> <span class="font-weight-medium">userInstanceId:</span> {{ userInstanceId }} </v-flex>
    <v-flex> <span class="font-weight-medium">accessToken:</span> {{ accessToken }} </v-flex>
    <v-flex> <span class="font-weight-medium">accessTokenExpirationTime:</span> {{ accessTokenExpirationTime }} </v-flex>
    <v-flex> <span class="font-weight-medium">refreshToken:</span> {{ refreshToken }} </v-flex>

    <v-flex class="mt-3"> <span class="font-weight-medium">attributionStatus:</span> {{ attributionStatus }} </v-flex>
    <v-flex> <span class="font-weight-medium">attributionId:</span> {{ attributionId }} </v-flex>
    <v-flex> <span class="font-weight-medium">attributionPlatform:</span> {{ attributionPlatform }} </v-flex>
    <v-flex> <span class="font-weight-medium">storeAttributionUrls:</span> {{ storeAttributionUrls }} </v-flex>
    <v-flex> <span class="font-weight-medium">organicStoreAttributionUrls:</span> {{ organicStoreAttributionUrls }} </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({

    }),
    methods: {

    },
    computed: {
      ...mapGetters([
        'appKey',
        'offer',
        'version',
        'deviceType',

        'sessionId',
        'url',
        'userAgent',
        'layoutId',

        'userInstanceId',
        'accessToken',
        'accessTokenExpirationTime',
        'refreshToken',

        'attributionStatus',
        'attributionId',
        'attributionPlatform',
        'storeAttributionUrls',
        'organicStoreAttributionUrls',
      ])
    },
    mounted () {
      this.$nextTick(function () {

      })
    },
    watch: {

    }
  }
</script>

<style>

</style>
